"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, Phone, Mail, MapPin } from "lucide-react";
export default function ContactInquiryCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="2554" id="contact" className="relative overflow-hidden bg-primary py-24 text-white md:py-32">
      {}
      <div className="pointer-events-none absolute right-0 bottom-0 h-full w-1/3 bg-white/5" aria-hidden="true" />
      
      <div ref={ref} className={`container relative z-10 mx-auto px-6 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:items-center">
          {}
          <div className="lg:col-span-7">
            <div className="mb-8">
              <span className="mb-4 block font-sans text-sm font-semibold tracking-[0.2em] uppercase text-secondary">
                Contact Inquiry
              </span>
              <h2 className="font-serif text-4xl leading-tight md:text-5xl">南フロリダ案件の初期相談をご予約ください。</h2>
            </div>

            <p className="mb-10 max-w-2xl font-sans text-lg leading-relaxed text-white/80 md:text-xl">日本語での初期連絡をご希望の場合は、現在の状況とお手元の関連資料についてお知らせください。</p>

            <div className="flex flex-col flex-wrap gap-4 sm:flex-row sm:items-center">
              <Link to="/InitialContactInJapanesePage">
                <Button size="lg" className="h-14 rounded-md bg-secondary px-8 text-base font-medium text-primary hover:bg-secondary/90">
                  日本語で初期連絡をする
                  <ArrowRight className="ml-2 size-4" />
                </Button>
              </Link>

              <Link to="tel:+19549259000">
                
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-5">
            <div className="rounded-lg border border-white/10 bg-white/5 p-8 shadow-2xl backdrop-blur-md md:p-10">
              <div className="space-y-8">
                <div className="group">
                  <div className="mb-2 flex items-center gap-3 text-secondary">
                    <Phone className="size-5" />
                    <span className="text-xs font-bold tracking-widest uppercase">Phone</span>
                  </div>
                  <Link to="tel:+19549259000" className="font-serif text-2xl transition-colors hover:text-secondary">
                    (954) 925-9000
                  </Link>
                </div>

                <div className="group border-t border-white/10 pt-8">
                  <div className="mb-2 flex items-center gap-3 text-secondary">
                    <Mail className="size-5" />
                    <span className="text-xs font-bold tracking-widest uppercase">Email</span>
                  </div>
                  <Link to="mailto:info@morrielevine.com" className="block break-all font-serif text-2xl transition-colors hover:text-secondary">
                    info@morrielevine.com
                  </Link>
                </div>

                <div className="group border-t border-white/10 pt-8">
                  <div className="mb-2 flex items-center gap-3 text-secondary">
                    <MapPin className="size-5" />
                    <span className="text-xs font-bold tracking-widest uppercase">Office Address</span>
                  </div>
                  <address className="not-italic font-sans text-lg leading-relaxed text-white/90">
                    3300 North 29th Avenue<br />
                    Suite 104<br />
                    Hollywood, FL 33020
                  </address>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}